/**
 * This is a Pill Selector Component.This Component is the Collection of thwe Pills which is to be displayed.The Component take the array of list data of message ,with active and disabled state.This compoenent can eb Used to Display various sizes in the product discription page.
 *
 * @module views/Atoms/PillSelector
 */
import './PillSelector.scss';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

import React from 'react';

import PropTypes from 'prop-types';
import SwiperCore, {
  Keyboard,
  Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import palette_variables from 'web-styles/src/_exports.module.scss';

import { useDeviceInflection } from '@ulta/core/providers/InflectionProvider/InflectionProvider';

import Pill from '../Pill/Pill';
import ProductDimension from '../ProductDimension/ProductDimension';
// install Swiper modules
SwiperCore.use( [Navigation, Keyboard] );

/**
 * Represents a PillSelector component
 *
 * @method
 * @param { PillSelectorProps } props - React properties passed from composition
 * @returns PillSelector
 */

export const PillSelector = function( props ){
  const {
    variants,
    typeLabel
  } = props;

  const { inflection } = useDeviceInflection();
  const selectedValue = variants.find( variant => variant.selected === true )?.name;

  const renderPills = ( item ) => {
    return (
      <Pill
        key={ item.name }
        active={ item.selected }
        disabled={ item.disabled }
        unavailable={ item.unavailable }
        message={ item.name }
        selectAction={ item.selectAction }
        linkSelectAction={ item.linkSelectAction }
        onClick={ ()=>{
          props.selectAction( item );
        } }
      />
    );
  };

  return (
    <div className='PillSelector'>
      <ProductDimension
        type={ typeLabel }
        description={ selectedValue }
      />
      <div className='PillSelector__pills'>
        { inflection.MOBILE &&
        <Swiper
          freeMode={ true }
          speed={ 600 }
          breakpoints={ {
            [palette_variables.breakpointSM]: {
              slidesPerView: 'auto'
            }
          } }
        >
          { variants.length > 1 && variants.map( ( item, index ) => {
            return (
              <SwiperSlide key={ index }>
                { renderPills( item ) }
              </SwiperSlide>
            );
          } )
          }
        </Swiper>
        }
        { inflection.DESKTOP &&
        <ul className='PillSelector__pills--inline'>
          { variants.length > 1 && variants.map( ( item, index ) => {
            return (
              <li key={ index }
                className='PillSelector__pills--inline__item'
              >
                { renderPills( item ) }
              </li>
            );
          } )
          }
        </ul>
        }
      </div>
    </div>
  );
};

/**
 * property type definitions
 * @typedef PillSelectorProps
 * @type object
 * @property {Array.<{ name: String, shadeDescription: String, swatchImage: object, smooshImage: object, selected: bool, disabled: bool, unavailable: bool, listPrice: String, salePrice: String, selectAction: object  }>} variants - this is array of Pills
 * @property {string} typeLabel - This is the value for Label.
 */
export const propTypes =  {
  productId: PropTypes.string,
  skuId: PropTypes.string,
  /** This is array of Pills */
  variants: PropTypes.arrayOf(
    PropTypes.shape( {
      name: PropTypes.string,
      shadeDescription: PropTypes.string,
      swatchImage: PropTypes.shape( {
        imageUrl: PropTypes.string,
        description: PropTypes.string
      } ),
      smooshImage: PropTypes.shape( {
        imageUrl: PropTypes.string,
        description: PropTypes.string
      } ),
      selected: PropTypes.bool,
      disabled: PropTypes.bool,
      unavailable: PropTypes.bool,
      listPrice: PropTypes.string,
      salePrice: PropTypes.string
    } )
  ).isRequired,
  selectAction: PropTypes.func,
  typeLabel: PropTypes.string
};

PillSelector.propTypes = propTypes;

export default PillSelector;